import { connect } from 'react-redux';

export default (mapStateToProps, mapDispatchToProps) => connect(mapStateToProps, mapDispatchToProps);



// WEBPACK FOOTER //
// ./src/hoc/withReduxData.js